import axios from "@/libs/api.request.js";
import { getEnv } from './heziShare'

// 获取bt盒子环境url
export const getBtBoxEnv = () => {
  switch (process.env.VUE_APP_ENV) {
    case "dev":
      return "https://btboxtest.hzwxbz999.cn";
    case "pre":
      return "https://btboxpre.hzwxbz999.cn";
    default:
      return "https://bthezi.hzwxbz3.cn";
  }
}; 

/**
 * 多域名信息
 */
export const getBtBoxHost = (data) => {
  return axios.request({
    url: `${getBtBoxEnv()}/box-active/domain/config`,
    data,
  });
}

export const sendPoint = (data) => axios.request({ url: `${getBtBoxEnv()}/box-user/bt-user/event-track`, data: {...data, btos: 'h5'} });
// 活动会场列表
export const getPlaceListApi= (data) => axios.request({ url: `${getBtBoxEnv()}/box-game/wheelV2/places`, data, requireToken: true});
// 抽奖活动导航栏信息
export const getPlaceBannerApi= (data) => axios.request({ url: `${getBtBoxEnv()}/box-game/wheelV2/draw/banner`, data, requireToken: true});
// 抽奖活动会场主页面
export const getPlaceInfoApi= (data) => axios.request({ url: `${getBtBoxEnv()}/box-game/wheelV2/draw/mainList`, data, requireToken: true});
// 活动抽奖
export const getDrawTurntableApi= (data) => axios.request({ url: `${getBtBoxEnv()}/box-game/wheelV2/draw/lottery`, data, requireToken: true});
// 中奖记录
export const getTurntableRecordApi= (data) => axios.request({ url: `${getBtBoxEnv()}/box-game/wheelV2/draw/record`, data, requireToken: true});
// 中奖记录游戏列表
export const getGamesListApi= (data) => axios.request({ url: `${getBtBoxEnv()}/box-game/wheelV2/draw/games`, data, requireToken: true});
// 转盘任务
export const getTaskListApi= (data) => axios.request({ url: `${getBtBoxEnv()}/box-game/wheelV2/draw/tasks`, data, requireToken: true});
// 完成任务
export const getCompleteTaskApi= (data) => axios.request({ url: `${getBtBoxEnv()}/box-game/wheelV2/draw/complete-task`, data, requireToken: true});

// 获取活动规则
export const getBtActRule = (params) => axios.request({ url: `${getBtBoxEnv()}/box-active/app/getAppDocList`, params, method: "get", requireToken: true });

export const getBtGameDetail = (params) =>
  axios.request({
    url: `${getBtBoxEnv()}/box-game/bt-game/games/${params.appkey}`,
    method: "get",
    params
  });

// 图文活动
export const getBtTemplateApi = (params) => axios.request({ url: `${getBtBoxEnv()}/box-active/bt-active/graphic-actives`, params, method: "get", requireToken: true });

/**
 * 周打卡活动游戏会场列表
 * @param {*} data 
 * @returns 
 */
export const getBtWeekSignInPlaceListApi= (data) => axios.request({ url: `${getBtBoxEnv()}/box-game/bt-game/weekly-clock/places`, data, requireToken: true});

/**
 * 周打卡活动主页面
 * @param {*} data 
 * @returns 
 */
export const getBtWeekSignInDetailApi= (data) => axios.request({ url: `${getBtBoxEnv()}/box-game/bt-game/weekly-clock/places/mainList`, data, requireToken: true});

/**
 * 用户打卡
 * @param {*} data 
 * @returns 
 */
export const setBtWeekSignInApi= (data) => axios.request({ url: `${getBtBoxEnv()}/box-game/bt-game/weekly-clock/places/signIn`, data, requireToken: true});

/**
 * 领取礼包
 * @param {*} data 
 * @returns 
 */
export const getBtWeekSignInGiftApi= (data) => axios.request({ url: `${getBtBoxEnv()}/box-game/bt-game/weekly-clock/places/gift-receive`, data, requireToken: true});

/**
 * 礼包领取记录
 * @param {*} data 
 * @returns 
 */
export const getBtWeekSignInGiftRecordApi= (data) => axios.request({ url: `${getBtBoxEnv()}/box-game/bt-game/weekly-clock/places/gift-record`, data, requireToken: true});

/**
 * 礼包领取记录-游戏列表信息
 * @param {*} data 
 * @returns 
 */
export const getBtGIftRecordGamesApi= (data) => axios.request({ url: `${getBtBoxEnv()}/box-game/bt-game/weekly-clock/places/games`, data, requireToken: true});

/**
 * 获取自定义图文配置
 * @param {*} data 
 * @returns 
 */
export const sendDeviceCodeApi = (data) => axios.request({ url: `${getBtBoxEnv()}/box-active/fission/deviceCodeReport`, data, headers: {'Content-Type': 'multipart/form-data'} });

/**
 * 累充活动首页
 * @param {*} data 
 * @returns 
 */
export const getBtPayAmountActivityConfigApi = (data) => axios.request({ url: `${getBtBoxEnv()}/box-active/payActivity/getHomeList`, data, requireToken: true });

/**
 * 累充活动礼包列表
 * @param {*} data 
 * @returns 
 */
export const getBtPayAmountActivityGiftsApi = (data) => axios.request({ url: `${getBtBoxEnv()}/box-active/payActivity/getGameGiftList`, data, requireToken: true });

/**
 * 累充活动领取礼包
 * @param {*} data 
 * @returns 
 */
export const receiveBtPayAmountActivityGiftApi = (data) => axios.request({ url: `${getBtBoxEnv()}/box-active/payActivity/drawGift`, data, requireToken: true,unHint: true });

// 拉新拉收-活动首页
export const expandUserActivityInfoApi = (data, isBt = false) => 
  axios.request({
    url: `${getBoxPrefix(isBt)}/collectActivity/getHomeList`,
    data,
    requireToken: true
  });

// 拉新拉收-活动礼包列表
export const expandUserActivityGiftListApi = (data, isBt = false) => 
  axios.request({
    url: `${getBoxPrefix(isBt)}/collectActivity/getGameGiftList`,
    data,
    requireToken: true
  });

// 拉新拉收-领取礼包
export const expandUserActivityDrawGiftApi = (data, isBt = false) => 
  axios.request({
    url: `${getBoxPrefix(isBt)}/collectActivity/drawGift`,
    data,
    requireToken: true,
    unHint: true
  });

// ----------- 游戏体验官 -----------
// 活动首页
export const getBtGameTesterHomeApi = (data) => 
  axios.request({ url: `${getBtBoxEnv()}/box-active/tasteActivity/homeList`, data, requireToken: true });

// 游戏会场
export const getGamePlaceApi = (data) => 
  axios.request({ url: `${getBtBoxEnv()}/box-active/tasteActivity/gameGiftList`, data, requireToken: true });

// 游戏会场领取礼包
export const receiveGameTesterGiftApi = (data) => 
  axios.request({ url: `${getBtBoxEnv()}/box-active/tasteActivity/drawGift`, data, requireToken: true, unHint: true });

// ----------- 多游戏转游 -----------
export const getBoxPrefix = (isBt = false) => {
  if (isBt) {
    return getBtBoxEnv() + '/box-active';
  } else {
    return getEnv() + "/wx-box-active"
  }
}
export const getBoxGamePrefix = (isBt = false) => {
  if (isBt) {
    return getBtBoxEnv() + '/box-game';
  } else {
    return getEnv() + "/wx-box-game"
  }
}
// 活动首页
export const getGameTransferHomeApi = (data, isBt = false) => 
  axios.request({
    url: `${getBoxPrefix(isBt)}/gameTransfer/homeList`,
    data,
    requireToken: true,
    unHint: true
  });

// 礼包页内游戏列表
export const getGameTransferGameListApi = (data, isBt = false) => 
  axios.request({
    url: `${getBoxPrefix(isBt)}/gameTransfer/unLockGameTabList`,
    data,
    requireToken: true
  });

// 礼包列表
export const getGameTransferGiftListApi = (data, isBt = false) => 
  axios.request({
    url: `${getBoxPrefix(isBt)}/gameTransfer/gameGiftList`,
    data,
    requireToken: true
  });


// 领取礼包
export const receiveGameTransferGiftApi = (data, isBt = false) => 
  axios.request({
    url: `${getBoxPrefix(isBt)}/gameTransfer/drawGift`,
    data,
    requireToken: true,
    unHint: true
  });

// 推荐游戏
export const getGameTransferRecommendListApi = (data, isBt = false) => 
  axios.request({
    url: `${getBoxPrefix(isBt)}/gameTransfer/recommendGameList`,
    data,
    requireToken: true
  });

// 注册返利活动 - 活动信息
export const getRegisterRebateInfo = (data, isBt = true) => {
  return axios.request({
    url: `${getBoxPrefix(isBt)}/register/voucher/info`,
    data,
    requireToken: true,
  })
}

// 注册返利活动 - 会场列表
export const getRegisterRebateList = (data, isBt = true) => {
  return axios.request({
    url: `${getBoxPrefix(isBt)}/register/voucher/placeList`,
    data,
    requireToken: true,
  })
}

// 注册返利活动 - 游戏返利
export const getRegisterRebateGame = (data, isBt = true) => {
  return axios.request({
    url: `${getBoxPrefix(isBt)}/register/voucher/detail`,
    data,
    requireToken: true,
  })
}

// 注册返利活动 - 明细记录
export const getRegisterRebateRecord = (data, isBt = true) => {
  return axios.request({
    url: `${getBoxPrefix(isBt)}/register/voucher/recordList`,
    data,
    requireToken: true,
  })
}

// 注册返利活动 - 兑换代金券
export const exchangeVoucherApi = (data, isBt = true) => {
  return axios.request({
    url: `${getBoxPrefix(isBt)}/register/voucher/exchange`,
    data,
    requireToken: true,
    unHint: true,
  })
}

// 注册返利活动 - 自定义兑换代金券
export const customExchangeVoucherApi = (data, isBt = true) => {
  return axios.request({
    url: `${getBoxPrefix(isBt)}/register/voucher/customExchange`,
    data,
    requireToken: true,
    unHint: true,
  })
}

// 注册返利活动 - 会场校验
export const checkVoucherPlaceApi = (data, isBt = true) => {
  return axios.request({
    url: `${getBoxPrefix(isBt)}/register/voucher/check`,
    data,
    requireToken: true,
  })
}

// 注册活跃活动 - 活动信息
export const getActiveInfoApi = (data, isBt = true) => {
  return axios.request({
    url: `${getBoxPrefix(isBt)}/register/active/info`,
    data,
    requireToken: true,
  })
}

// 注册活跃活动 - 会场列表
export const getActivePlaceListApi = (data, isBt = true) => {
  return axios.request({
    url: `${getBoxPrefix(isBt)}/register/active/placeList`,
    data,
    requireToken: true,
  })
}

// 注册活跃活动 - 校验会场状态
export const checkActivePlaceApi = (data, isBt = true) => {
  return axios.request({
    url: `${getBoxPrefix(isBt)}/register/active/check/place`,
    data,
    requireToken: true,
  })
}

// 注册活跃活动 - 会场详情
export const getActivePlaceDetailApi = (data, isBt = true) => {
  return axios.request({
    url: `${getBoxPrefix(isBt)}/register/active/place/detail`,
    data,
    requireToken: true,
  })
}

// 注册活跃活动 - 记录列表
export const getActiveRecordListApi = (data, isBt = true) => {
  return axios.request({
    url: `${getBoxPrefix(isBt)}/register/active/recordList`,
    data,
    requireToken: true,
  })
}

// 注册活跃活动 - 兑换
export const exchangeActiveApi = (data, isBt = true) => {
  return axios.request({
    url: `${getBoxPrefix(isBt)}/register/active/draw`,
    data,
    requireToken: true,
    unHint: true,
  })
}

// 游戏攻略详情
export const getGameStrategyDetailApi = (data, isBt = true) => {
  return axios.request({
    url: `${getBoxGamePrefix(isBt)}/gameGuide/guideDetail${isBt ? '/v2' : ''}`,
    data,
    requireToken: true,
  })
}

// 获取游戏攻略头部信息
export const getGameGuideHeadInfoApi = (data, isBt = true) => {
  return axios.request({
    url: `${getBoxGamePrefix(isBt)}/gameGuide/gameGuideHeadInfo`,
    data,
    requireToken: true,
  })
}

// 获取游戏攻略标签列表
export const getTagGuideListApi = (data, isBt = true) => {
  return axios.request({
    url: `${getBoxGamePrefix(isBt)}/gameGuide/tagGuideList${isBt ? '/v2' : ''}`,
    data,
    requireToken: true,
  })
}

// 获取收藏标签列表
export const getCollectedGuideListApi = (data, isBt = true) => {
  return axios.request({
    url: `${getBoxGamePrefix(isBt)}/gameGuide/collectGuideList${isBt ? '/v2' : ''}`,
    data,
    requireToken: true,
    requireLogin: true,
  })
}

// 点赞/取消点赞
export const likeGameStrategyApi = (data, isBt = true) => {
  return axios.request({
    url: `${getBoxGamePrefix(isBt)}/gameGuide/praiseOrCancelGuide${isBt ? '/v2' : ''}`,
    data,
    requireToken: true,
    requireLogin: true,
  })
}

// 收藏/取消收藏
export const collectGameStrategyApi = (data, isBt = true) => {
  return axios.request({
    url: `${getBoxGamePrefix(isBt)}/gameGuide/collectOrCancelGuide${isBt ? '/v2' : ''}`,
    data,
    requireToken: true,
    requireLogin: true,
  })
}

// 攻略游戏列表
export const getGameStrategyListApi = (data, isBt = true) => {
  return axios.request({
    url: `${getBoxGamePrefix(isBt)}/gameGuide/game/list`,
    data,
    requireToken: true,
    requireLogin: true,
  })
}
